module.exports = __webpack_public_path__ + "img/no-live-video-bg.b3070d0c.png";